import React, { useState, useMemo, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronLeft, ChevronRight } from 'lucide-react';
import ProductCard from '../ProductCard/ProductCard';
import { products } from '../../data/products';
import './FeaturedProducts.css';

const FeaturedProducts = () => {
  const [activeTab, setActiveTab] = useState('sale');
  const scrollerRef = useRef(null);

  const filteredProducts = useMemo(() => {
    switch (activeTab) {
      case 'women':
        return products.filter((p) => (p.categories || [p.category]).some((c) => c.toLowerCase() === 'women')).slice(0, 12);
      case 'men':
        return products.filter((p) => (p.categories || [p.category]).some((c) => c.toLowerCase() === 'men')).slice(0, 12);
      case 'sale':
        return products.filter((p) => p.salePrice).slice(0, 12);
      case 'new':
        return products.filter((p) => p.badge === 'NEW').slice(0, 12);
      default:
        return products.slice(0, 12);
    }
  }, [activeTab]);

  const tabs = [
    { id: 'sale', label: 'On sale' },
    { id: 'women', label: 'Women' },
    { id: 'men', label: 'Men' },
    { id: 'new', label: 'New' },
    { id: 'all', label: 'For you' },
  ];

  const scrollBy = (dir) => {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * 280, behavior: 'smooth' });
  };

  return (
    <section className="featured-products">
      <div className="featured-products-inner">
        <div className="featured-products-header">
          <div>
            <h2 className="featured-products-title">Looking for something else?</h2>
            <p className="featured-products-lede">Hand-picked styles and markdowns — just for you.</p>
          </div>
          <div className="featured-products-controls">
            <button type="button" className="featured-nav-btn" onClick={() => scrollBy(-1)} aria-label="Scroll left">
              <ChevronLeft size={20} />
            </button>
            <button type="button" className="featured-nav-btn" onClick={() => scrollBy(1)} aria-label="Scroll right">
              <ChevronRight size={20} />
            </button>
          </div>
        </div>

        <div className="featured-products-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`featured-products-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="featured-products-scroller" ref={scrollerRef}>
          {filteredProducts.map((product) => (
            <div key={product.id} className="featured-products-slide">
              <ProductCard product={product} />
            </div>
          ))}
        </div>

        <div className="featured-products-footer">
          <Link to="/shop" className="featured-products-view-all">
            Shop the full catalog <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
